import circuitImage from "../../assets/images/pcb_board.png";
import { Box } from "@mui/system";
import React from "react";
import { useForm } from "react-hook-form";
import CheckInput from "../../molecules/CheckInput";
import { CustomSlider } from "../../molecules/CustomSlider";
import { CsTextField } from "../../molecules/CustomTextField";
const currencies = [
  {
    value: "USD",
    label: "$ Dollar",
  },
  {
    value: "EUR",
    label: "€ Euro",
  },
  {
    value: "BTC",
    label: "฿ Bitcoin",
  },
]; //demo data

const Presets = () => {
  const { register, handleSubmit, control } = useForm();
  const [value, setValue] = React.useState([20, 37]);
  const valuetext = (value) => {
    return value;
  };
  const [currency, setCurrency] = React.useState("EUR");

  const handleSelectChange = (event) => {
    setCurrency(event.target.value);
  };

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="w-5/6 m-auto md:w-4/5 md:my-16">
      <div className="grid md:grid-cols-5 gap-1 md:gap-3">
        {/* Left items */}
        <div className="col-span-2">
          <CsTextField
            required
            id="outlined-required"
            label="project name"
            defaultValue=""
            size="small md:large"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <div className="my-2 md:my-6">
            <div className="font-medium text-lg md:text-xl my-2">
              inout power
            </div>
            <CheckInput
              id="loremCheck1"
              text="lorem + lorem power"
              control={control}
            />
            <CheckInput
              id="loremCheck2"
              text="only lorem power"
              control={control}
            />
          </div>
          <Box sx={{ width: 300, color: "green" }}>
            <CustomSlider
              getAriaLabel={() => "Temperature range"}
              value={value}
              onChange={handleSliderChange}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
            />
          </Box>

          <div className="font-medium text-lg md:text-xl my-1 md:my-2">
            lorem options
          </div>
          <CheckInput
            id="loremCheck1"
            text="lorem + lorem power"
            control={control}
          />
          <CheckInput
            id="loremCheck2"
            text="only lorem power"
            control={control}
          />
        </div>

        {/* Right items */}
        <div className="col-span-3">
          <div className="font-medium text-lg md:text-xl mb-4 md:mb-8">
            lorem options
          </div>
          <div className="md:w-1/3 my-4">
            <CsTextField
              id="filled-select-currency-native"
              select
              variant="standard"
              color="success"
              sx={{ backgroundColor: "white" }}
              fullWidth
              value={currency}
              onChange={handleSelectChange}
              SelectProps={{
                native: true,
              }}
            >
              {currencies.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </CsTextField>
          </div>

          {/* Input Section */}
          <div className="flex flex-wrap  md:flex-nowrap space-y-4 md:space-y-0 md:space-x-4 md:my-12">
            <div className="">
              <CsTextField
                required
                id="outlined-required"
                label="height"
                defaultValue=""
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div>
              <CsTextField
                required
                id="outlined-required"
                label="width"
                defaultValue=""
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div>
              <CsTextField
                id="outlined-select-currency-native"
                select
                type="number"
                value={currency}
                onChange={handleSelectChange}
                SelectProps={{
                  native: true,
                }}
              >
                {currencies.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </CsTextField>
            </div>
          </div>
          <div className="flex justify-center p-5 md:p-0">
            <img className="" src={circuitImage} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Presets;
